import { cn } from "../../lib/cn";

export type StageTone = "neutral" | "emerald" | "amber" | "brand";

export interface PipelineStageProps {
  label: string;
  value: number;
  sub?: string;
  tone: StageTone;
  onClick?: () => void;
  icon?: React.ReactNode;
}

const ICON_BG: Record<StageTone, string> = {
  neutral: "bg-datahub-gray-1500 text-ash",
  emerald: "bg-emerald-50 text-emerald-600",
  amber: "bg-amber-50 text-amber-600",
  brand: "bg-brand-50 text-brand-600",
};

const VALUE_COLOR: Record<StageTone, string> = {
  neutral: "text-ink",
  emerald: "text-emerald-700",
  amber: "text-amber-700",
  brand: "text-brand-700",
};

export function PipelineStage({
  label,
  value,
  sub,
  tone,
  onClick,
  icon,
}: Readonly<PipelineStageProps>) {
  const inner = (
    <>
      <div
        className={cn(
          "flex h-8 w-8 shrink-0 items-center justify-center rounded-md",
          ICON_BG[tone],
        )}
      >
        {icon}
      </div>
      <div className="min-w-0">
        <div className="eyebrow">{label}</div>
        <div
          className={cn(
            "mt-0.5 font-display text-[34px] font-semibold leading-none tracking-tight",
            VALUE_COLOR[tone],
          )}
          data-num
        >
          {value}
        </div>
        {sub && <div className="mt-1 text-[11.5px] text-ash">{sub}</div>}
      </div>
    </>
  );

  if (onClick) {
    return (
      <button
        onClick={onClick}
        className="flex w-full items-center gap-3 px-5 py-5 text-left transition-colors hover:bg-paper"
      >
        {inner}
      </button>
    );
  }
  return <div className="flex items-center gap-3 px-5 py-5">{inner}</div>;
}
